import { Preferences } from '@capacitor/preferences'

const COMPANY_ID_KEY = 'active_company_id'
let cachedCompanyId: string | null = null

export async function setActiveCompanyId(id: string | null) {
  cachedCompanyId = id
  if (id) {
    await Preferences.set({ key: COMPANY_ID_KEY, value: id })
  } else {
    await Preferences.remove({ key: COMPANY_ID_KEY })
  }
}

export async function getActiveCompanyId(): Promise<string | null> {
  if (cachedCompanyId) return cachedCompanyId
  const { value } = await Preferences.get({ key: COMPANY_ID_KEY })
  cachedCompanyId = value
  return value
}

export function getCachedCompanyId(): string | null {
  return cachedCompanyId
}
